import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import BasicOptionCard from '../OptionCard/variants/BasicOptionCard';

const OptionCardGroup = ({
  options = [],
  initialSelectedOptions = [],
  groupName,
  type = 'checkbox',
  isDisabled,
  onChange,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions || []);

  const onOptionSelect = option => {
    if (type === 'radio') {
      if (selectedOptions.some(selectedOption => selectedOption?.value === option.value)) return;
      setSelectedOptions([option]);
      return;
    }

    if (selectedOptions.some(selectedOption => selectedOption?.value === option.value)) {
      setSelectedOptions(current => {
        return current.filter(selectedOption => selectedOption.value !== option.value);
      });
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  useEffect(() => {
    onChange?.(selectedOptions);
  }, [selectedOptions, onChange]);

  return (
    <div>
      {options.map(option => {
        if (option.hasOwnProperty('visible') && !option.visible) return;

        const OptionComponent = BasicOptionCard;
        return (
          <div key={`${groupName}_${option.value || option.headline}`} className="w-full">
            <OptionComponent
              variant={type}
              value={option.value}
              description={option.description}
              label={option.label}
              iconName={option.iconName}
              labelName={groupName}
              subtitle={option.subtitle}
              isSelected={selectedOptions.some(
                selectedOption => selectedOption?.value === option.value,
              )}
              isDisabled={option.isDisabled || isDisabled}
              onChange={() => onOptionSelect(option)}
            />
          </div>
        );
      })}
    </div>
  );
};

const OptionType = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  iconName: PropTypes.string,
});
OptionCardGroup.propTypes = {
  options: PropTypes.arrayOf(OptionType),
  initialSelectedOptions: PropTypes.arrayOf(OptionType),
  type: PropTypes.oneOf(['checkbox', 'radio']),
  groupName: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default OptionCardGroup;
